import HomeScreen from "../HomeScreen/HomeScreen";
// import classplusLogo from "../../assets/Images/classplus-logo.png";
// import rightArrow from "../../assets/Images/arrow-gray.png";
import { AndroidScreen } from "../../components/AndroidScreen";
import { useState } from "react";
import "./DesktopScreen.css";
import "../../components/Common/scss/main.scss";
import Features from "../../components/Common/Features/Features";
import FeaturesList from "../../components/Common/Features/FeaturesList";
import Institutes from "../../components/Common/Institutes/Institutes";
import Footer from "../../components/Common/Footer/Footer";
import Header from "../../components/Common/Header/Header";
import InstitutesList from "../../components/Common/Institutes/InstitutesList";
import CircleBackground from "../../assets/Images/Subtract.svg";
import Testimonial from "../../components/Common/Testimonial/Testimonial";

const DesktopScreen = () => {
  const [numberSubmitted, setNumberSubmitted] = useState(false);
  const [instituteName, setInstituteName] = useState("");
  const [showRadarScreen, setShowRadarScreen] = useState(false);

  return (
    <>
    <Header />

      <div className="relative flex flex-row justify-around items-center desktopScreen mr-20 mb-18" style={{height: "70%", paddingBottom: "4em"}}>
        
        {!showRadarScreen && <div className="sauravDadaImgDesktop" />}

        <div className={`flex justify-center flex-col left ml-24 mt-3 mb-8`}>
          {instituteName ? (
            <>
              <h2
                className="font-bold not-italic text-4xl desktopHeading mb-6"
                style={{ color: "#45c5ff" }}
              >
                Hi, {instituteName}
              </h2>
              {numberSubmitted && (
                <div className="androidScreenWrapper">
                  <AndroidScreen
                    desktopView={true}
                    userInputs={{}}
                    instituteName={instituteName}
                  />
                </div>
              )}
            </>
          ) : (
            <>
              <h1
                className="font-bold not-italic desktopHeading mb-6 text-[#009ae0]" style={{color:"#009ae0"}}
              >
                Become India’s Top Educator With Your Own App!
              </h1>
              <div>
                <ul className="leading-10 ml-4">
                  <li style={{listStyleType: "disc"}}>
                      <span className="ml-2">Grow your teaching business by 10x</span>
                  </li>
                  <li style={{listStyleType: "disc"}}>
                      <span className="ml-2">
                      Upload & sell your courses
                      </span>
                  </li>
                  <li style={{listStyleType: "disc"}}>
                  <span className="ml-2">
                  Become a brand of your own
                  </span>
                  </li>
                </ul>
              </div>
            </>
          )}
          <div className="mt-8 flex flex-row">
            <div className="text-center  lg:pr-2 xl:pr-6" style={{borderRight: "1px solid rgba(230, 230, 230, 1)"}}>
              <p className="colorBlue text-2xl font-bold leading-10">3000+</p>
              <span>Cities</span>
            </div>
            <div className=" text-center lg:px-2 xl:px-6" style={{borderRight: "1px solid rgba(230, 230, 230, 1)"}}>
              <p className="colorBlue text-2xl leading-10">1 Lakh+</p>
              <span>Teachers</span>
            </div>
            <div className="text-center lg:px-2 xl:px-6 ">
              <p className="colorBlue text-2xl font-bold leading-10">1 Crore+</p>
              <span>Students</span>
            </div>
          </div>

          {/* <div className="fixed w-1/4 imgContainerNew">
              <img src={SouravDadaImage} alt="sourav-dada" />
               <img className="absolute bg-contain bg-no-repeat z-10 right-0 sauravDadaImg" />
            </div> */}
        </div>

        <div className="right">
          <HomeScreen
            desktopView={true}
            setNumberSubmitted={setNumberSubmitted}
            setInstituteName={setInstituteName}
            showRadarScreen={showRadarScreen}
            setShowRadarScreen={setShowRadarScreen}
          />
        </div>

        <img src={CircleBackground} className="bottomImg"/>
      </div>
      <Features />
      <FeaturesList />
      <Institutes />
      <Testimonial />
      <div className="institutes__content">
        <InstitutesList />
      </div>
      <Footer />
    </>
  );
};

export default DesktopScreen;
